import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { WebShopService } from "../../services/webShop.service";
import { CoreLanguageService } from "../../services/language.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { GroupMemberOrderDetailService } from "./groupMemberOrderDetail.service";
import { Observable } from "rxjs";
import { IMemberGroupBasketItem, IMemberOrderedItem, IMemberInfo, IMenuCourse, OrderedItemState, IMemberInfo_NotificationTyp } from "./groupMemberOrderDetail.facade";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { ChangePhoneNumberDialogComponent, SecureCheckDialogComponent } from "../../modalDialogs";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { slideInFade } from "../../shared/animation/component.animation";
import { InHouseOrderService } from "../../services/inHouseOrder.service";

@Component({
  selector: "groupMemberOrderDetail",
  templateUrl: "./groupMemberOrderDetail.component.html",
  styleUrls: ["./groupMemberOrderDetail.component.scss"],
  providers: [GroupMemberOrderDetailService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideInFade]
})

export class GroupMemberOrderDetailComponent implements OnInit, OnDestroy {
  private _langSubscriber: Subscription;
  private _memberDataChangedSubscriber: Subscription;

  public isSmallView: boolean = false;
  public commentVisibleInitilize: boolean = true;

  public stateValue = OrderedItemState;
  public isOwner: boolean = false;
  public memberInfo$: Observable<IMemberInfo>;
  public open_price$: Observable<number>;
  public memberGroupBasketItems$: Observable<IMemberGroupBasketItem[]>;
  public memberOrderedItems$: Observable<IMemberOrderedItem[]>;
  public menucourses$: Observable<IMenuCourse[]>;
  public userToken: string;
  public IMemberInfo_NotificationTyp = IMemberInfo_NotificationTyp;
  public userPhoneNumber$: Observable<string>;
  private _userPhoneNumberChangedSubscriber: Subscription;
  private userPhoneNumber: string = "";
  public useEPing: boolean = false;

  constructor(private _location: Location
    , private _inHouseOrderService: InHouseOrderService
    , private _router: Router
    , private _activatedRoute: ActivatedRoute
    , private _groupMemberOrderDetailService: GroupMemberOrderDetailService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _mainnavService: MainnavService
    , private internationalisationService: InternationalisationService
    , private _webShopService: WebShopService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _overlaySpinnerService: OverlaySpinnerService) {
    const me = this;
    me.isSmallView = me._mainnavService.viewType === ViewType.Small;
    me.open_price$ = me._groupMemberOrderDetailService.open_price$;
    me.memberInfo$ = me._groupMemberOrderDetailService.memberInfo$;
    me.memberGroupBasketItems$ = me._groupMemberOrderDetailService.memberGroupBasketItems$;
    me.memberOrderedItems$ = me._groupMemberOrderDetailService.memberOrderedItems$;
    me.menucourses$ = me._groupMemberOrderDetailService.menucourses$;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._memberDataChangedSubscriber) {
      me._memberDataChangedSubscriber.unsubscribe();
    }
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._userPhoneNumberChangedSubscriber) {
      me._userPhoneNumberChangedSubscriber.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("GroupMemberOrderComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me._activatedRoute.paramMap.subscribe(params => {
      me.userToken = params.get("userToken");
    });

    me._groupMemberOrderDetailService.useNotification().then((val) => {
      me.useEPing = val;
    });
    me.userPhoneNumber$ = me._groupMemberOrderDetailService.phoneNumber$;
    if (me._userPhoneNumberChangedSubscriber)
      me._userPhoneNumberChangedSubscriber.unsubscribe();
    me._userPhoneNumberChangedSubscriber = me.userPhoneNumber$.subscribe((userPhoneNumber) => {
      me.userPhoneNumber = userPhoneNumber;
      me.PushChanges();
    });

    me._groupMemberOrderDetailService.initialise(me.userToken).then(() => {

      me.isOwner = me._groupMemberOrderDetailService.isOwner;
      me.PushChanges();
    }).catch((error) => {
      me._coreLogService.error("GroupMemberOrderDetailComponent.ngOnInit", "_groupMemberOrderDetailService.initialise catch", error);
    })

    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
  }

  public formatCurrency(price: number): string {
    return this._webShopService.formatCurrency(price);
  }

  public get SMSNotificationLabel() {
    const me = this;
    return me._coreLanguageService.value("phInHouse_SMS_Notification")
      .replace("{phoneNumber}", `<span class="emphasized">${me.userPhoneNumber}</span>`);
  }
  public get changeNumberSubText(): string {
    const me = this;
    return this._coreLanguageService.value("phChangePhoneNumber_SubText")
      .replace("{phoneNumber}", `<span class="emphasized">${me.userPhoneNumber}</span>`);
  }

  /** Open change phone number dialog */
  public async ChangePhoneNumber(): Promise<boolean> {
    const me = this;

    return new Promise<boolean>((resolve, reject) => {
      const dialog = me._bottomSheetHelperService.open(ChangePhoneNumberDialogComponent, {
        data: {
          title: "phChangePhoneNumber_Title",
          description: me.changeNumberSubText,
          buttonTextAccept: "phChangePhoneNumber_Btn_Label",
          buttonTextDeny: "phGlobal_Return",
        },
        autoFocus: false,
      });
      dialog.afterDismissed().subscribe(async (number) => {
        if (number) {
          me._overlaySpinnerService.ShowLayoutSpinner();
          const success = await me._groupMemberOrderDetailService.ChangePhoneNumber(number);
          me._overlaySpinnerService.HideLayoutSpinner();
          if (success) {
            return resolve(true);
          } else {
            me.changePhoneNumberFailedDialog();
            return resolve(false);
          }
        } else {
          return resolve(false);
        }
      });
    });
  }

  public isGroupCreator(): boolean {
    const isCreator = this._inHouseOrderService.GroupCreator === this._inHouseOrderService.UserNickname;
    return isCreator;
  }

  /** change phone number failed */
  public changePhoneNumberFailedDialog() {
    const me = this;
    me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phChangePhoneNumber_Failed_Title",
        description: "phChangePhoneNumber_Failed_Desc",
        buttonTextAccept: "phGlobal_Continue",
        icon: "shop-icons.svg#ya-hypersoft-achtung",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    })
  }

  /** navigate to payment */
  public navigateToPayment() {
    const me = this;
    me._router.navigate(["/inHausePayment"]);
  }

  /** Navigate to Menugroup */
  public async navigateToMenuGroup() {
    const me = this;
    me._router.navigate(["/menugroup"]);
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }
  /** navigate back */
  public navigateBack(): void {
    this._location.back();
  }
}